import React, { Component } from "react";
import Slider from "react-slick";
import Image from "../../components/Image";

export default function MainSlider() {
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <Slider className="mainSlider " {...settings}>
        <div className="mainSlider_slide">
          <Image src="./assets/images/slide1.jpeg" />
          <div className="mainSlider_slideinfo">
            <h3>Sports Automation</h3>
            {/* <p>Lorem ips Sit Ametum Dolor Sit Amet</p> */}
          </div>
        </div>
        <div className="mainSlider_slide">
          <Image src="./assets/images/slide2.png" />
          <div className="mainSlider_slideinfo">
            <h3>Sports Automation</h3>
            {/* <p>Lorem ips Sit Ametum Dolor Sit Amet</p> */}
          </div>
        </div>
        <div className="mainSlider_slide">
          <Image src="./assets/images/slide3.jpg" />
          <div className="mainSlider_slideinfo">
            <h3>Sports Automation</h3>
            {/* <p>Lorem ips Sit Ametum Dolor Sit Amet</p> */}
          </div>
        </div>
      </Slider>
    </>
  );
}
